'use client';
import React from 'react';
import Button from '@elements/button';
import Div from '@pezeshk-book/ui-kit/div';
import { LikeBoxProps } from '@modules/like-box/like-box.props';
import { AuthActions } from '@store/auth/auth-actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import DislikeIcon from '@icons-components/dislike-icon';
import LikeIcon from '@icons-components/like-icon';

const LikeBox = ({ like, dislike, handleLike, handleDislike }: LikeBoxProps) => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);

  const handleLikeFunction = () => {
    if (!isLoggedIn) {
      dispatch(AuthActions.setLoginModal({ loginModal: true }));
    } else {
      handleLike();
    }
  };

  const handleDislikeFunction = () => {
    if (!isLoggedIn) {
      dispatch(AuthActions.setLoginModal({ loginModal: true }));
    } else {
      handleDislike();
    }
  };

  return (
    <Div className={`gap-2 sm:gap-5 items-center`}>
      <Button
        onClick={handleDislikeFunction}
        color={'control'}
        variant={'text'}
        size={'small'}
        startAdornment={<DislikeIcon/>}
        className={'items-center !p-0'}>
        {dislike}
      </Button>
      <Button
        onClick={handleLikeFunction}
        color={'control'}
        variant={'text'}
        size={'small'}
        startAdornment={<LikeIcon/>}
        className={'items-center !p-0'}>
        {like}
      </Button>
    </Div>
  );
};

export default LikeBox;
